/* eslint-disable no-shadow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { growlErrors } from '../../../utils/NotificationUtil';
import { Loading } from '../../../components/Loading';
import { withGrowl } from '../../../components/GrowlNotifications';
import {
  growlShape,
} from '../../../components/prop-types';

import { withAccount } from '../../../components/AccountContext';
import { parse, filterPaginationWithSize } from '../../../utils/UrlUtil';

import TransferForm from './TransferForm';

export const NEW_TRANSFER_QUERY = gql`
  query NewTransferQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      displayName
    }
  }
`;

export const NEW_TRANFER_MUTATION = gql`
  mutation NewTransfer($input: TransferCreditsInput!) {
    transferCredits(input: $input) {
      transfer {
        id
        amount
        transferReason
        transactionTime
      }
    }
  }
`;

class TransfersQuery extends Component {
  static propTypes = {
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    currentAccount: PropTypes.number.isRequired,
  };

  render() {
    const { currentAccount, location, growl } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);

    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort,
      filter: params.filter,
    };

    return (
      <Query query={NEW_TRANSFER_QUERY} variables={variables}>
        {({ data, loading, error }) => {
          if (error) {
            growlErrors(growl, error);
          }
          if (loading) return <Loading />;

          const account = data && data.account ? data.account : { id: currentAccount, label: 'CurrentAccount' };

          return (
            <Mutation mutation={NEW_TRANFER_MUTATION}>
              {(transferCredits, mutationResult) => (
                <TransferForm
                  account={account}
                  loading={loading}
                  currentAccount={currentAccount}
                  transferCredits={transferCredits}
                  mutationResult={mutationResult}
                />
              )}
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

TransfersQuery.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(withRouter(injectIntl(withAccount(TransfersQuery))));
